class WorkbenchRequirementTemplatesMgmtCtrl {
  constructor($uibModalInstance) {
    'ngInject';

    this.$uibModalInstance = $uibModalInstance;
  }
}

export default WorkbenchRequirementTemplatesMgmtCtrl;
